import React, { useEffect, useState } from 'react';
import SelectListField from '../../../components/Fields/SelectListField';
import { FieldProps, SelectListOption } from '../../../components/Fields/Types';
import { useNotifications } from '../../../contexts/notificationContext';
import { useTranslations } from '../../../contexts/translationContext';
import BusinessPartnerTypeModel from '../../../models/BusinessPartnerTypeModel';
import WorkflowTaskAddBusinessPartnerModel from '../../../models/WorkflowTaskAddBusinessPartnerModel';
import DataService from '../../../services/data.service';

interface IProps {
    formData: WorkflowTaskAddBusinessPartnerModel
    getFieldProps: (fieldName: string) => FieldProps

}
const TaskAddBusinessPartnerView: React.FC<IProps> = ({formData, getFieldProps}) => {
    const [businessPartners, setBusinessPartners] = useState<SelectListOption[]>([]);
    const [contactpersons, setContactpersons] = useState<SelectListOption[]>([]);
    const { handleException } = useNotifications();
    const { translate } = useTranslations();

    useEffect(() => {
        getBusinessPartners(formData.businessPartnerType);
    }, [formData.businessPartnerType]);

    useEffect(() => {
        if (formData.businessPartnerId)
            getContactpersons(formData.businessPartnerId);
    }, [formData.businessPartnerId]);

    function getBusinessPartners(businessPartnerType: BusinessPartnerTypeModel) {
        translate('-- Select ' + businessPartnerType.name).then(translated => {
            DataService.get<SelectListOption[]>('api/v1/selectlist/businessPartners?activeOnly=true&businessPartnerTypeId=' + businessPartnerType.id + '&nullOption=' + translated)
                .then(response => setBusinessPartners(response))
                .catch(e => handleException(e));
        });
    }

    function getContactpersons(businessPartnerId: number) {
        translate('-- Select contactperson').then(translated => {
            DataService.get<SelectListOption[]>('api/v1/selectlist/ContactPersons?businessPartnerId=' + businessPartnerId + '&nullOption=' + translated)
                .then(response => setContactpersons(response))
                .catch(e => handleException(e));
        });
    }


    return (
        <>
            <SelectListField {...getFieldProps('workflowTaskAddBusinessPartnerModel.businessPartnerId')} options={businessPartners} />
            <SelectListField {...getFieldProps('workflowTaskAddBusinessPartnerModel.contactPersonId')} options={contactpersons} />
        </>
    )

}
export default TaskAddBusinessPartnerView;